// extracted by mini-css-extract-plugin
module.exports = {"list":"div_list__uPubA","item":"div_item__7_xMY","link":"div_link__ZC55u","orderedList":"div_orderedList__v4lHq"};